export default {
  data () {
    return {
      error: '',
      uuidFileName: ''
    }
  },
  methods: {
    uploadFile (file, fileType, presignedUrl, uuidFileName) {
      // Must use XHR until this issue gets fixed: https://github.com/mzabriskie/axios/issues/382
      let xhr = new XMLHttpRequest()
      xhr.open('PUT', presignedUrl)
      xhr.setRequestHeader('Content-type', fileType)
      let postData = new FormData()
      postData.append('file', file)

      // This little hacky gift courtesy of: https://github.com/enyo/dropzone/issues/590
      let _send = xhr.send
      xhr.send = function () {
        _send.call(xhr, file)
      }

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 204) {
            this.error = ''
            this.uuidFileName = uuidFileName
          } else {
            this.error = 'Error uploading file'
            console.log('upload failed')
          }
        }
      }
      xhr.send(postData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/uploadToS3.js